import React from "react";

import { IAddFavoriteBtn } from "../@types";
import TooltipButton from "../TooltipButton";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

export const AddFavoriteQueryBtn = ({
  onClick,
  disabled,
  label
}: IAddFavoriteBtn) => (
  <TooltipButton
    onClick={() => onClick({ type: SEARCH_MODALS_NAMES.ADD_FAVOURITE })}
    type="favorite"
    label={label || "Save query as favorite"}
    disabled={disabled}
  />
);
